"use strict";

exports.__esModule = true;
var _ElementEditorSidebar = require("./ElementEditorSidebar");
Object.keys(_ElementEditorSidebar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorSidebar[key]) return;
  exports[key] = _ElementEditorSidebar[key];
});